import DomainConfigurationDNSSettingsTable from './DomainConfigurationDNSSettingsTable'

export default DomainConfigurationDNSSettingsTable
